module.exports = __webpack_public_path__ + "static/media/user_interview.00085298.png";